export default class ScoreCalculator {

    constructor(gameConfig) {
        this._gameConfig = gameConfig;
        this._featureScore = gameConfig.getValue("scoring.featureScore");
        this._orderScore = gameConfig.getValue("scoring.orderScore");
        this._itemFeatures = this._gameConfig.getValue("scoring.features");
    }

    calculatePuzzleScore(goal, state) {
        this._gameConfig.getValue("scoring");
        let score = 0;
        state.forEach((item, idx) => {
            if (item != null) {
                //check if item is part of solution
                const goalIdx = goal.indexOf(item);
                if (goalIdx == idx) {
                    score += 1;
                } else if (goalIdx > -1) {
                    //wrong slot
                    score += this._orderScore;
                } else {
                    //compare features of item in slot with goal at same index
                    const itemFeatures = this._getItemFeatures(item);
                    const goalItemFeatures = this._getItemFeatures(goal[idx]);
                    let count = 0;
                    for (const feature in itemFeatures) {
                        if (itemFeatures[feature] == goalItemFeatures[feature]) {
                            count ++;
                        }
                    }
                    score += Math.min(1, this._featureScore * count);
                }
            }
        });
        score /= goal.length;
        return score;
    }


    _getItemFeatures(item) {
        const itemName = this._gameConfig.getItemSkin(item);
        return this._itemFeatures[itemName];
    }
};
